import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext({ token: null, login: async () => {}, logout: async () => {}, username: "", loading: true });

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("furshala_admin_token"));
  const [username, setUsername] = useState(localStorage.getItem("furshala_admin_username") || "");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verify = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const res = await api.get("/admin/me");
        setUsername(res.data.username);
        localStorage.setItem("furshala_admin_username", res.data.username);
      } catch (e) {
        localStorage.removeItem("furshala_admin_token");
        localStorage.removeItem("furshala_admin_username");
        setToken(null);
        setUsername("");
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [token]);

  const login = async (u, p) => {
    const res = await api.post("/admin/login", { username: u, password: p });
    localStorage.setItem("furshala_admin_token", res.data.token);
    localStorage.setItem("furshala_admin_username", res.data.username);
    setToken(res.data.token);
    setUsername(res.data.username);
    return res.data;
  };

  const logout = async () => {
    try {
      await api.post("/admin/logout");
    } catch (err) {
      // Network/server error during logout is non-fatal; we still clear local state.
      console.warn("Logout API call failed (continuing local sign-out):", err?.message || err);
    }
    localStorage.removeItem("furshala_admin_token");
    localStorage.removeItem("furshala_admin_username");
    setToken(null);
    setUsername("");
  };

  // Memoise the context value to avoid re-rendering every consumer on each render.
  const value = useMemo(
    () => ({ token, username, login, logout, loading }),
    [token, username, loading]
  );

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
